var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { title: "Bitácora", "hide-footer": "", centered: "" },
      on: { close: _vm.closeModal },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [_c("BinnacleList", { attrs: { binnacles: _vm.binnacle } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }